import { PowerProfileDataPoint, allDays } from 'greener-ui-library';

/**
 * Parse CSV power profile data to PowerProfileDataPoint array
 * CSV format: week_day,time,power_demand_kw
 * Example: 0,22:00,0.2
 */
export const parsePowerProfileCsv = (csvData: string): PowerProfileDataPoint[] => {
  const dataPoints: PowerProfileDataPoint[] = [];
  const lines = csvData.trim().split('\n');

  // Skip header line (index 0)
  for (let i = 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) {
      continue;
    }

    const [weekDay, time, powerDemandKw] = line.split(',');

    // Convert week_day (0-6) to day name
    const dayIndex = parseInt(weekDay);
    const day = allDays[dayIndex];

    // Parse time (HH:MM) to hour
    const [hours] = time.split(':');
    const hour = parseInt(hours);

    const timestamp = `${dayIndex}:${time}`;

    dataPoints.push({
      timestamp,
      power: parseFloat(powerDemandKw),
      day,
      hour,
      dayIndex,
    });
  }

  return dataPoints;
};
